import { action, makeObservable, observable } from 'mobx';
import ITreeNode from '../../../components/tree/ITreeNode';
import TreeLinkNode from './TreeLinkNode';
import ISerializable from '../../../lib/ISerializable';

export default class TreeLinkedList implements ISerializable {
  public head: TreeLinkNode = null;

  public currentPointer: TreeLinkNode = null;

  constructor() {
    makeObservable(this, {
      head: observable,
      currentPointer: observable,
      addNode: action,
      resetPointer: action,
      reset: action,
      setCurrentPointer: action,
      next: action
    });
  }

  serialize(): string {
    // serialize the linked list
    let current = this.head;
    let serializedList = [];

    while (current) {
      serializedList.push(current.getId());
      current = current.getNext();
    }

    return JSON.stringify(serializedList);
  }

  deserialize(serializedList: any): void {
    for (let i = 0; i < serializedList.length; i++) {
      this.addNode({ id: serializedList[i] } as any);
    }

    this.resetPointer();
  }

  /**
   * Used for mobx reactions
   *
   * @returns
   */
  toJSON(): any {
    let current = this.head;
    let serializedList = [];

    while (current) {
      serializedList.push(current.getId());
      current = current.getNext();
    }

    return {
      head: this.head ? this.head.getId() : null,
      currentPointer: this.currentPointer ? this.currentPointer.getId() : null,
      serializedList: serializedList
    };
  }

  addNode(node: ITreeNode) {
    let newNode = new TreeLinkNode(node.id);

    if (this.head === null) {
      this.head = newNode;
    } else {
      let current = this.head;

      while (current.getNext()) {
        current = current.getNext();
      }

      current.setNext(newNode);
      newNode.setPrevious(current);
    }
  }

  reset() {
    this.head = null;
    this.currentPointer = null;
  }

  resetPointer() {
    this.currentPointer = this.head;
  }

  setCurrentPointer(nodeId: string | number) {
    let current = this.head;

    while (current) {
      if (current.getId() === nodeId) {
        this.currentPointer = current;
        break;
      }

      current = current.getNext();
    }
  }

  next() {
    if (this.currentPointer) {
      let current = this.currentPointer;
      this.currentPointer = current.getNext();
      return current;
    }

    return null;
  }

  previous() {
    if (this.currentPointer) {
      let current = this.currentPointer;
      this.currentPointer = current.getPrevious();
      return current;
    }

    return null;
  }

  getCurrentPointer() {
    return this.currentPointer;
  }
}
